module.exports = __webpack_public_path__ + "img/icon_dashboard_white.f67517b1.svg";